import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 760px)';

function getInitialMode() {
  if (typeof window === 'undefined') return 'desktop';
  return window.matchMedia(MOBILE_QUERY).matches ? 'mobile' : 'desktop';
}

export function useViewportMode() {
  const [mode, setMode] = useState(getInitialMode);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const updateMode = (event) => setMode(event.matches ? 'mobile' : 'desktop');

    updateMode(mediaQuery);
    mediaQuery.addEventListener('change', updateMode);

    return () => mediaQuery.removeEventListener('change', updateMode);
  }, []);

  return mode;
}
